module.exports = __webpack_public_path__ + "static/media/team.fefa7c3b.png";